import { ReactNode, useEffect, useState } from "react";
import CustomFileWrapper from "../../../learner/components/Problem/CustomFileWrapper";
import PortalModal from "../../../shared/PortalModal";
import {
  LearnerProblemResponse,
  LogData,
  Problem,
} from "../../../learner/types";
import { executeQuery } from "../../../utils";
import { useQuery } from "@tanstack/react-query";
import { obfuscate } from "../../../student/utils";
import StatusTags from "../../../learner/components/Problem/StatusTags";
import { renderA11yString } from "../../../student/utils/render-a11y-string";

export const LearnerSolutionModal: React.FC<{
  children: (onClick: () => void) => ReactNode;
  logId: string;
}> = ({ children, logId }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [problem, setProblem] = useState<Problem | undefined>();
  const [logData, setLogData] = useState<LogData | undefined>();

  if (!window.renderA11yString) {
    // Not ideal but is used in dmGraph so we need it on the window
    window.renderA11yString = renderA11yString;
  }

  const closeModal = () => {
    setIsVisible(false);
    setProblem(undefined);
    setLogData(undefined);
  };

  const { data: problemData } = useQuery<LearnerProblemResponse>({
    queryKey: ["/manager_new/parent-portal/learner_problem_support/log", logId],
    queryFn: () =>
      executeQuery({
        path: `/manager_new/parent-portal/learner_problem_support/log?logId=${logId}`,
      }),
    enabled: isVisible,
  });

  useEffect(() => {
    if (problemData) {
      setProblem({
        ...problemData,
        lines: problemData.lines || [],
        data:
          typeof problemData.data === "string"
            ? obfuscate(`${problemData._id}`).reveal(`${problemData.data}`)
            : problemData.data,
      });
      setLogData(problemData.log_data);
    }
  }, [problemData]);

  return (
    <>
      <div>{children(() => setIsVisible(true))}</div>

      <PortalModal
        visible={isVisible}
        onClose={closeModal}
        largeModal
        title="Learner Solution"
        body={
          <>
            {problem ? (
              <CustomFileWrapper
                skillId=""
                key={`renderKey-${problem._id}`}
                problem={problem}
                logData={logData}
                checkAnswer={() => {
                  console.log("CHECK ANSWER");
                }}
                isCheckAnswerLoading={false}
                unsubmitAllowed={false}
                showSolutions={true}
                inModal
                noBorder
                header={
                  <StatusTags
                    skillCode={problem.skillcode}
                    logData={logData}
                    questionTitle={""}
                    solutionShowing={true}
                    assignmentType="practice"
                  />
                }
              />
            ) : (
              "Loading..."
            )}
          </>
        }
      />
    </>
  );
};
